import { AuthLoginResponseType } from '@/modules/auth/constants/AuthLoginResponseType';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export default class AuthLoginResponse extends BaseModel {
  type: AuthLoginResponseType;
  authUser: AuthUser | null;
  otpToken?: string;

  constructor(model: Partial<AuthLoginResponse> = {}) {
    super(model);

    this.type = model.type!;
    this.authUser = AuthUser.mapModelOrNull(model.authUser);
    this.otpToken = model.otpToken;
  }

  get isSuccess(): boolean {
    return this.type === AuthLoginResponseType.SUCCESS;
  }

  get isOtp(): boolean {
    return this.type === AuthLoginResponseType.OTP;
  }
}
